<template>
    <nav class="sticky-nav">
        <ul class="sticky-nav--list u-reset">
            <li v-if="backLink">
                <a class="sticky-nav--link u-reset" :href="backLink">
                    <ui-icon class="sticky-nav--icon" symbol="arrow-left" size="medium"/>
                    {{ backLabel }}
                </a>
            </li>
            <li class="sticky-nav--item"
                    :class="[bemAdd(i === activeIndex ? 'active' : 'base', 'item')]"
                    v-for="(item, i) in items"
                    :key="i">
                <a class="sticky-nav--link u-reset" :href="getAnchorId(item)">
                    {{ item.label }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import $ from 'bianco.query';
    import { mapState } from 'vuex';
    import { elementOffsetTop } from 'bianco.viewport';

    export default {
        components: {
            UiIcon,
        },
        mixins: [bemMixin('sticky-nav')],
        props: {
            items: {
                type: Array,
                required: true,
            },
            backLink: {
                type: String,
                default: '',
            },
            backLabel: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                activeIndex: null,
            };
        },
        computed: {
            ...mapState('vue-ui/scroll', {
                scrollPosition: 'position',
            }),
            ...mapState('viewport', {
                viewportWidth: 'width',
            }),
            anchorOffsets() {
                // this.viewportWidth here is only needed to compute this function whenever the viewport changes
                // without it vue will never update this value
                this.viewportWidth; // eslint-disable-line

                return this.anchors.map(s => Math.floor(elementOffsetTop(s)));
            },
        },
        methods: {
            getAnchorId(item) {
                return `#anchor-${ item.id }`;
            },
            onScroll(scrollPosition) {
                // reverse all the anchor offsets to find the active index starting from the last one
                const activeIndex = [...this.anchorOffsets].reverse().findIndex(o => scrollPosition >= o);
                // the right active index must be remapped because we have reversed the anchorOffsets list
                // the findIndex method will give use always the inverse index of the current active menu item
                const mapIndex = index => (this.anchorOffsets.length - 1) - index;

                // if an active index was found we map it to the proper one otherwise we fall back to the first item
                this.activeIndex = activeIndex > -1 ? mapIndex(activeIndex) : 0;
            },
        },
        watch: {
            scrollPosition(value) {
                this.onScroll(value);
            },
        },
        mounted() {
            this.anchors = this.items
                .map(item => $(this.getAnchorId(item))[0])
                .filter(Boolean);

            this.onScroll(this.scrollPosition);
        },
    };
</script>
